import { cn } from "utils/cn";

export const BotAction: React.FunctionComponent<
  React.ComponentPropsWithoutRef<"button">
> = (props) => (
  <button
    {...props}
    className={cn(
      "inline-flex cursor-pointer items-center gap-1.5 rounded-sm border-0 bg-zi-lightPrimary p-1 font-sans text-[15px] font-semibold text-zi-primary transition-shadow focus-within:outline-none focus-within:ring-1 focus-within:ring-zi-primary focus-within:ring-offset-2 focus-within:ring-offset-zi-lightPrimary hover:bg-zi-primary/20 hover:focus-within:ring-offset-zi-primary/20",
      props.className
    )}
  />
);
